<!--
 * @Description: 客户价值 模块
-->
<template>
  <div class="custom">
    <section class="custom_card custom_bg_img rn-section-gap">
      <div class="container custom_content">
        <SectionTitle
          :title="$t('solution.values_title')"
          description="VALUES"
          textAlign="center"
        />
        <div class="custom_content_01">
          <div :class="customState === 'center'? 'card_img center_img' : 'card_img right_img'">
            <img src="@/assets/images/IndustrySolution/customValue/bg_img01.png" />
          </div>
          <div v-if="pageLayout === 'leftFive'" class="page_layout_01">
            <div class="row">
              <div class="col-12 col-lg-7 col-md-12 col-sm-12 row gx-5">
                <div
                  v-for="(item, index) in list"
                  :key="index"
                  :class="
                    index === 0 || index === 1
                      ? 'col-lg-6 col-md-6 col-sm-12 col-12 p-3'
                      : 'col-lg-4 col-md-4 col-sm-12 col-12 p-3'
                  "
                  :data-aos="
                    index === 0
                      ? 'fade-right'
                      : index === 1
                      ? 'fade-left'
                      : 'fade-up'
                  "
                  :data-aos-delay="
                    index === 0 || index === 2
                      ? '100'
                      : index === 1 || index === 3
                      ? '150'
                      : '200'
                  "
                >
                  <div class="content">
                    {{ item.title }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="pageLayout === 'leftFour'" class="page_layout_02">
            <div class="row col-lg-6 col-md-12 col-sm-12 col-12">
              <div
                v-for="(item, index) in list"
                :key="index"
                :class="
                  index === 0 || index === 2
                    ? 'content_card col-12 pb--30 ml--80 ml_md--20 ml_sm--0'
                    : index === 1
                    ? 'content_card col-12 pb--30'
                    : 'content_card col-12 ml--40 ml_md--10 ml_sm--0'
                "
              >
                <div class="content">
                  {{ item.title }}
                </div>
              </div>
            </div>
          </div>
          <div v-if="pageLayout === 'centerFour'" class="page_layout_03">
            <div class="row">
              <div
                v-for="(item, index) in list"
                :key="index"
                :class="
                  index === 0 || index === 3
                    ? 'content_card col-lg-6 col-md-6 col-sm-12 col-12 ptb--20 pr--60 pr_md--0 pr_sm--0'
                    : 'content_card col-lg-6 col-md-6 col-sm-12 col-12 ptb--20 pl--60 pl_md--0 pl_sm--0'
                "
              >
                <div class="content">
                  {{ item.title }}
                </div>
              </div>
            </div>
          </div>
          <div v-if="pageLayout === 'leftThreeHover'" class="page_layout_04">
            <div class="row col-lg-6 col-md-12 col-sm-12 col-12">
              <div
                v-for="(item, index) in list"
                :key="index"
                :class="
                  index === 0
                    ? 'content_card col-12 ml--80 ml_md--0 ml_sm--0 pb--40'
                    : index === 1
                    ? 'content_card col-12 ml--195 ml_md--0 ml_sm--0 pb--40'
                    : 'content_card col-12'
                "
              >
                <div class="content">
                  {{ item.title }}
                  <div class="desc">
                    {{ item.desc }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import SectionTitle from '@/components/elements/sectionTitle/SectionTitle'

export default {
  name: 'CustomValue',
  components: { SectionTitle },
  props: {
    /**
     * 背景图片样式
     * center：居中; right: 右边;
    */
    'customState': {
      type: String,
      default: '',
    },
    /**
     * 背景图片样式
     * leftFive：左侧5个; leftFour：左侧四个; leftThreeHover: 左侧三个带hover效果; 
     * centerFour: 居中4个
    */
    'pageLayout': {
      type: String,
      default: '',
    },
    /**
     * list: 数组
     * 格式：[{ title: '1' },{ title: '2' }]
     * leftThreeHover 格式：[{ title: '1', desc:'1' },{ title: '2', desc:'2' }]
     */
    list: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
    }
  },
  methods: {

  }
}
</script>